"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var success_1 = require("../../../build-babel/auth/response/success");
var redirect_1 = require("../../../build-babel/redirect");
var token_1 = require("../../../build-babel/token");
var storage_1 = require("../../../build-babel/token/storage");
var handleResponse = function handleResponse(msalClient, response) {
  if (response !== null) {
    var existingToken = (0, storage_1.getToken)();
    var idToken = response.idToken,
      account = response.account;
    msalClient.setActiveAccount(account);
    if (!(0, token_1.hasValidToken)(existingToken)) {
      (0, success_1.handleSuccess)(response);
    }
    (0, redirect_1.redirectNext)(idToken);
  }
};
exports["default"] = handleResponse;
//# sourceMappingURL=handler.js.map